import { Pipe, PipeTransform } from '@angular/core';
import { CustomerSupplierType } from '~core/models/customer-supplier.model';

@Pipe({
  name: 'customerSupplierType',
  pure: true,
  standalone: true
})
export class CustomerSupplierTypePipe implements PipeTransform {
  private readonly _typeMap: Record<CustomerSupplierType, string> = {
    [CustomerSupplierType.bToB]: 'Entreprise locale',
    [CustomerSupplierType.bToC]: 'Particulier',
    [CustomerSupplierType.bToF]: 'Entreprise internationale',
    [CustomerSupplierType.bToG]: 'Entité gouvernementale'
  };

  transform(type: CustomerSupplierType | string | undefined): string {
    if (!type) return 'Inconnu';
    return this._typeMap[type as CustomerSupplierType] || type || '';
  }
}
